export default __webpack_public_path__ + "static/media/transform-lifes-4-colombia.423dc5b7.png";